<template>
  <v-container>
    <v-layout wrap >
      <v-flex xs12 lg8 offset-lg2 pa-4 text-center>
        <v-layout wrap>

          <v-flex xs12>
            <v-img :src="require('@/assets/img/logo/logo_transparent_background.png')" contain max-height="300" class="mx-auto" />
          </v-flex>

          <v-flex xs12>

            <template v-if="loading" >
              <v-progress-circular size="80" indeterminate width="2" color="primary" class="mb-3">
                <v-icon class="cc-icon" color="primary">fas fa-credit-card</v-icon>
              </v-progress-circular>
              <div class="caption">Un momento por favor...</div>
            </template>

            <v-scale-transition>
              <v-layout wrap v-show="showResult" class="text-center">

                <template v-if="success">
                  <v-flex xs12 class="text-center">
                    <v-icon size="60" color="success">mdi-check</v-icon>
                  </v-flex>
                  <v-flex xs12 class="text-center">
                    <div class="body mt-2">¡Subscripción exitosa! redirigiendo en {{redirectCount}}...</div>
                  </v-flex>
                </template>

                <template v-else>

                  <v-flex xs12 >
                    <div class="body">¡Ups! el proceso ha fallado. Inténtalo mas tarde...</div>
                    <v-btn class="mt-2 px-4" small rounded :to="{
                      name: 'panel.provider.settings',
                      query: {
                        view: 'SubscriptionSettings'
                      }
                    }">Volver a mi subscripcion</v-btn>
                  </v-flex>
                </template>

              </v-layout>
            </v-scale-transition>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {ApiUtils} from "@/utils/ApiUtils";

export default {
  name: "PanelSubscriptionValidation",
  data(){
    return {
      loading: true,
      success: false,
      showResult: false,
      redirectCount: 5,
      redirectInterval: null
    }
  },
  mounted() {
    const vm = this
    setTimeout(function(){
      vm.validateSubscription()
    }, 3000)
  },
  methods:{
    startCountDown(){
      const vm = this
      vm.redirectInterval = setInterval(function(){
        if(vm.redirectCount === 1){
          clearInterval(vm.redirectInterval)
          vm.$router.replace({
            name: 'panel.provider.settings',
            query: {
              view: 'SubscriptionSettings'
            }
          })
        }
        vm.redirectCount--
      }, 1000)
    },
    async validateSubscription(){
      const vm = this

      const response = await ApiUtils.makeGet(`public/subscriptions/validate/${vm.token}`)
      vm.success = response.ok
      vm.loading = false
      vm.showResult = true
      if(response.ok){
        await ApiUtils.fetchMe()
        vm.startCountDown()
      }
    }
  },
  computed:{
    token(){
      return this.$route.params.token
    }
  }
}
</script>

<style scoped>

  .cc-icon{
    animation: cc-anim infinite 1s;
  }

  @keyframes cc-anim {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    50% {
      -webkit-transform: scale3d(1.3, 1.3, 1.3);
      transform: scale3d(1.3, 1.3, 1.3);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

</style>
